import React from 'react';

import AddressLabel from './AddressLabel';
import Title from './Title';

interface Props {
    address: string;
    allowEdit: boolean;
    title: string;

    children?: React.ReactChild;
    onEditClick: React.MouseEventHandler<Element>;
}

const HeaderSearch = (props: Props) => {
    return (
        <div className="row bor-b-0-xs bor-b-0-sm pad-t-7 pad-b-2">
            <div className="col-xs-24">
                <h1 className="mar-0 mar-b-2">
                    <Title className="display-block font-8 font-feature" text={props.title} />
                    <AddressLabel address={props.address} allowEdit={props.allowEdit} onEditClick={props.onEditClick} />
                </h1>
            </div>
            {props.children}
        </div>
    );
};

export default HeaderSearch;
